import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { faArrowLeft, faPlusLarge } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function KalenderDesktopContent() {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex gap-2 items-start justify-between pb-6 w-full">
        <div className="flex items-center gap-2">
          <Link
            to="/termine/uebersicht"
            aria-label={t('domain.termine.title')}
            title={t('domain.termine.title')}
            className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }))}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Link>
          <span className="font-semibold text-sm">
            {t('domain.termine.title')}
          </span>
        </div>
        <div className="flex justify-end gap-2 items-center">
          <Button variant="default" size="icon" className="mt-10">
            <FontAwesomeIcon icon={faPlusLarge} className="font-bold" />
          </Button>
        </div>
      </div>
    </>
  );
}
